/** @jsx jsx */
import { ClassNames, jsx } from '@emotion/react';
import ContactForm from 'components/ContactForm';
import Container from 'components/Container';
import React from 'react';
import { FormattedMessage } from 'react-intl';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ApplicationDetailFormProps extends React.HTMLAttributes<HTMLDivElement> {}

const ApplicationDetailForm = React.forwardRef<HTMLDivElement, ApplicationDetailFormProps>(({ ...rest }, ref) => {
  return (
    <ClassNames>
      {({ theme }) => (
        <Container
          maxWidth='lg'
          css={{
            '@media(min-width: 600px)': {
              padding: theme.spacing(0, 2),
            },
          }}
        >
          <div
            ref={ref}
            {...rest}
            css={{
              '@media(min-width: 960px)': {
                borderBottom: '1px solid',
                borderBottomColor: theme.palette.primary.main,
                padding: theme.spacing(4, 0),
              },
              alignItems: 'flex-start',
              display: 'flex',
              flexGrow: 1,
              justifyContent: 'flex-start',
              padding: theme.spacing(2, 0),
              width: '100%',
            }}
          >
            <div
              css={{
                alignItems: 'flex-start',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
              }}
            >
              <div
                css={{
                  ...theme.typography.h2,
                  marginBottom: theme.spacing(1),
                  maxWidth: 500,
                  padding: theme.spacing(0, 2),
                }}
              >
                <FormattedMessage id={'services.form.title'} />
              </div>
              <ContactForm formPosition='applicationDetail' />
            </div>
          </div>
        </Container>
      )}
    </ClassNames>
  );
});

export default ApplicationDetailForm;
